module.exports = __webpack_public_path__ + "media/stockholm/small_subway_model-925d7b8e.jpg";